import React, { useState, useEffect } from 'react';
import Loading from '../Components/Loading';
import AreaPatientList from '../Components/AreaPatientList';
import CensoSearch from '../Components/CensoSearch';
import CensoFilters from '../Components/CensoFilters';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import moment from 'moment';
//Net services
import { getCensoIngresosCuentas, 
        getCensoEgresosCuentas,
        getCensoCuentas } from '../Services/Net/Request/CensoServices';
import { GetAreasPaciente } from '../Services/Net/Request/AreaServices';

//import { HandleError } from "../Services/Net/Request/NetService";

export default function CensoPage(props)
{
    const [status, setStatus] = useState("");
    const [refresh, setRefresh] = useState(false);
    const [dateday, setDateday] = useState(new Date());
    const [daterange, setDaterange] = useState(0);
    const [pstatus, setPstatus] = useState(0);
    const [pservice, setPservice] = useState(0);
    const [filters, SetFilters] = useState(false);
    const [colaps, setColaps] = useState(false);
    const [search, setSearch] = useState("");
    const [query, setQuery] = useState("");
    const [Ambulatorios, setAmbulatorios] = useState(0);
    const [Hospitalizados, setHospitalizados] = useState(0);
    const [Virtuales, setVirtuales] = useState(0);
    const [Porcent, setPorcent] = useState(0);
    const [Capacidad, setCapacidad] = useState(0);
    const [AdeudosTipo, setAdeudosTipo] = useState([0,0,0,0]);
    const [Areas, setAreas] = useState({
        All: undefined,
        Hos: undefined,
        Amb: undefined,
        Vir: undefined
    });
    const [FechaRango, setFechaRango] = useState({
        inicial: moment().startOf('day'),
        final: moment().endOf('day')
    });

    useEffect(() => {
        const abortController = new AbortController();
        setStatus("?");
        setAreas({ All: undefined, Hos: undefined, Amb: undefined, Vir: undefined});
        setAdeudosTipo([0,0,0,0]);

        var promise = null;
        const formatdate = "YYYY-MM-DD HH:mm:ss";
        switch(pstatus)
        {
            case 1: //ingresos
                promise = getCensoIngresosCuentas(abortController.signal, FechaRango.inicial.format(formatdate), FechaRango.final.format(formatdate))
            break;
            case 2: //egresos
                promise = getCensoEgresosCuentas(abortController.signal, FechaRango.inicial.format(formatdate), FechaRango.final.format(formatdate));
            break;
            default:
                promise = getCensoCuentas(abortController.signal);
        }

        var promiseareas = GetAreasPaciente();
            Promise.all([promise, promiseareas]).then(
                (response) => {
                    if (abortController.signal.aborted)
                        return;

                    if (response[0].ok && response[1].ok)
                    {
                        setStatus("");
                        response[0].json().then((data) => {

                            response[1].json().then((areasdata) => {
                                
                                var ambulatorios = 0;
                                var hospitalizados = 0;
                                var virtuales = 0;
                                var adeudos = [0,0,0,0];
                                var CapTotal = 0;
                                var Personas = 0;

                                areasdata.forEach((a) => {

                                    a['Pacientes'] = data.filter((p) => p['AreaID'] === a['AreaID']);
                                
                                    a['AdeudoArea'] = 0;
                                    a['Pacientes'].forEach(element => {
                                        adeudos[0] += element.Adeudo;
                                        adeudos[a['Tipo']] += element.Adeudo;
                                        a['AdeudoArea'] += element.Adeudo;
                                    });
                            
                                    a['Tipo'] === 1 ? (hospitalizados += a['Pacientes'].length) : 
                                    a['Tipo'] === 2 ? (ambulatorios += a['Pacientes'].length) : (virtuales += a['Pacientes'].length);
                                    
                                    //if (a.Capacidad > 0 && a['Tipo'] === 1 && a.Area !== "CUNEROS") //Solo Hospitalizados que no sea cuneros
                                    //Areas que si mostraran porcentajes
                                    a.addcount = a.Capacidad > 0 && a['Tipo'] === 1 && a.Area !== "CUNEROS";
                                    //Cuenta Global
                                    if (a.Capacidad > 0 && a.Area.startsWith("HOSP PISO")) //Solo Hospitalizados de piso
                                    {
                                        let personas = a['Pacientes'];
                                        
                                        // if (a.Area === "URGENCIAS")
                                        // {
                                        //     personas = personas.filter(f => 
                                        //         !f.Habitacion.startsWith('CONS') 
                                        //         && !f.Habitacion.startsWith('VAL')
                                        //         && !f.Habitacion.startsWith('TRI'));
                                        //     a.Porcentaje = a.Capacidad > 0 ? Math.round((personas.length/a.Capacidad)*100) : 0 ;
                                        // }
                                        
                                        Personas += personas.length;
                                        CapTotal += a.Capacidad;
                                    }
                                    
                                    //filtros
                                    const AreaPatiens = a['Pacientes'];

                                    a['Pacientes'] = pservice === 0 ? AreaPatiens : 
                                    (pservice===1 ? AreaPatiens.filter(f => f.Servicio_medico !== "PARTICULAR") :
                                    AreaPatiens.filter(f => f.Servicio_medico === "PARTICULAR"));
                     
                                    if (query !== "")
                                        a['Pacientes'] = AreaPatiens.filter(f => 
                                            f.Fullname.toLowerCase().includes(query.toLowerCase())
                                            || f.Medico.toLowerCase().includes(query.toLowerCase()));
                                    
                                });
                                
                                setCapacidad(CapTotal);
                                setPorcent(CapTotal > 0 ? Math.round((Personas/CapTotal)*100) : 0);
                                setAmbulatorios(ambulatorios);
                                setHospitalizados(hospitalizados);
                                setVirtuales(virtuales);
                                setAdeudosTipo(adeudos);
                                setAreas({
                                    All: areasdata,
                                    Hos: areasdata.filter((a) => a['Tipo'] === 1),
                                    Amb: areasdata.filter((a) => a['Tipo'] === 2),
                                    Vir: areasdata.filter((a) => a['Tipo'] !== 1 && a['Tipo'] !== 2)
                                });
                            });
                        });
                    } else {
                        setStatus("Error de conexión");
                    }
                }
            ).catch(function(error) { 
                if (!abortController.signal.aborted)
                    setStatus("Error de conexión: "+error); });

        return () => {
            abortController.abort();
            };
      },[refresh,pstatus,pservice,FechaRango,query,props.hospital]);

    function ChangeDateRange(value)
    {
        switch(value)
        {
            case 0://hoy
                    setFechaRango({
                        inicial:moment().startOf('day'),
                        final:moment().endOf('day')
                    });
                break;
            case 1://semana
                    setFechaRango({
                        inicial:moment().startOf('isoWeek'),
                        final:moment().endOf('isoWeek')
                    });
                break;
            case 2://mes
                    setFechaRango({
                        inicial:moment().startOf('month'),
                        final:moment().endOf('month')
                    });
                break;
            case 3://dia
                    setFechaRango({
                        inicial:moment(dateday).startOf('day'),
                        final:moment(dateday).endOf('day')
                    });
                break;
            default:
                {
                    setFechaRango({
                        inicial:moment().startOf('day'),
                        final:moment().endOf('day')
                    });
                }
        }
        setDaterange(value);
    }

    function Search()
    {
        if(search==="")
            setRefresh(!refresh)
            else
            setQuery(search);
    }

    function EnterSearch(e)
    {
        if (e.key === 'Enter')
            setQuery(search);
    }

    function ChangeDateDay(date)
    {
        setFechaRango({
            inicial:moment(date).startOf('day'),
            final:moment(date).endOf('day')
        });
        setDateday(date);
    }

    const TxtService = ["Todos","Asegurado","Particular"];
    const TxtStatus = ["Actuales","Ingresados","Egresados"];
    const TxtDate = ["Hoy","Semana","Mes","Dia"];

    const filterdata = { 
        colaps, 
        dateday, 
        daterange, 
        pstatus, 
        pservice, 
        TxtService,
        TxtStatus,
        TxtDate };

    return(
    <section>
        <CensoSearch
            filteron={filters}
            search={search}
            setFilteron={(ison) => SetFilters(ison)}
            setSearch={(v) => setSearch(v)}
            SearchQuery={() => Search()}
            entrysearch={EnterSearch}
            />
        <CensoFilters
            {...filterdata}
            setDateday={(v) => ChangeDateDay(v)}  
            setDaterange={(v) => ChangeDateRange(v)}
            setPstatus={(v) => setPstatus(v)}
            setPservice={(v) => setPservice(v)}
            setColaps={(ison) => setColaps(ison)}
            groupLabel="Solo areas"
            show={filters}/>
        <div className='tc'>
            <Loading status={status}/>
        </div>
        <Tabs defaultActiveKey="all" transition={false} id="noanim-tab-example" hidden={status === "?"}>
            <Tab eventKey="all" title={'Todos ('+(Ambulatorios+Hospitalizados+Virtuales)+')'}>
                <AreaPatientList active={colaps} apdata={Areas.All} adeudo={AdeudosTipo[0]}
                    capacidad={Capacidad} porcentaje={Porcent}/>
            </Tab>
            <Tab eventKey="hos" title={'Hospitalizados ('+Hospitalizados+')'}>
                <AreaPatientList active={colaps} apdata={Areas.Hos} adeudo={AdeudosTipo[1]}
                    capacidad={0} porcentaje={0}/>
            </Tab>
            <Tab eventKey="amb" title={'Ambulatorios ('+Ambulatorios+')'}>
                <AreaPatientList active={colaps} apdata={Areas.Amb} adeudo={AdeudosTipo[2]}
                    capacidad={0} porcentaje={0}/>
            </Tab>
            <Tab eventKey="lab" title={'Imagen/Lab. ('+Virtuales+')'}>
                <AreaPatientList active={colaps} apdata={Areas.Vir} adeudo={AdeudosTipo[3]}
                    capacidad={0} porcentaje={0}/>
            </Tab>
        </Tabs>
    </section>
    );
}